<template lang="pug">
v-card.mb-4(outlined)
  template(v-if="user.profile.email_verified_at")
    v-card-text.d-flex.flex-row
      v-icon(color="success").mr-2 mdi-check-bold
      p.title.mb-0 Ваша почта {{ user.profile.email }} подтверждена
  template(v-else)
    v-card-title Подтверждение почты
    v-card-text
      v-form(v-model="valid")
        v-text-field.mr-2(
          v-model="email"
          :rules="[rules.email]"
          filled
          label="Почта"
          required
          type="email"
        )
      v-btn(
        :loading="loadingUpdate"
        :disabled="!valid"
        @click="updateProfile"
        color="primary"
      ) Отправить письмо
</template>

<script>
import { mapGetters } from 'vuex';
import rules from '@/lib/rules';

export default {
  data() {
    return {
      valid: false,
      email: '',

      loadingUpdate: false,
      rules,
    };
  },
  computed: {
    ...mapGetters({
      'user':'auth/getUser',
    }),
  },
  created() {
    this.email = this.user?.profile?.email;
  },

  methods: {
    updateProfile() {
    },

  },
};
</script>

<style></style>
